import React from 'react'
import optionsIconImage from './options-icon.svg'
import styles from '../AttachmentsList.module.css'

const Options: React.FC = () => {
  return (
    <div aria-label='options' className={`${styles.optionsIconContainer} cursor-pointer float-right absolute-content`}>
      <img alt='Options Icon' src={optionsIconImage} className={`${styles.optionIcon}`} data-testid={'optionsIcon'} />
    </div>
  )
}

export default Options
